<template>
    <div class="input-group">
        <input type="text" v-model="question" @input="onChange" class="form-control autocomplete" :placeholder="ph"
            ref="inputField" @keydown.down="onArrowDown" @keydown.up="onArrowUp" @keydown.enter="onEnter" 
            :title="question"/>
        <ul v-show="isOpen" class="autocomplete-results">
            <li v-for="(result, idx) in results" :key="idx" @click="setResult(result)" class="autocomplete-result"
                :class="{ 'is-active': idx === arrowCounter }">
                {{ result }}
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props: {
        items: {
            type: Array,
            required: false,
            default: () => [],
        },
        modelValue: {},
        ph: {
            type: String,
            required: false,
            default: '',
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            question: '',
            results: [],
            isOpen: false,
            arrowCounter: -1,
            prevMatch: '',
        }
    },
    methods: {
        filterResults() {
            if (this.question.length < 3) {
                return false;
            }
            const hasPrevMatch = this.prevMatch.length > 0;
            let ctx2Match = '';
            if (hasPrevMatch) {
                const idx = this.question.toLowerCase().lastIndexOf(this.prevMatch.toLowerCase());
                if (idx !== -1) {
                    ctx2Match = this.question.substring(idx);
                } else {
                    const tokens = this.question.split(/\s+/);
                    if (tokens.length === 0 || tokens[tokens.length - 1].length < 3) {
                        this.prevMatch ='';
                        return false;
                    }
                    ctx2Match = tokens[tokens.length - 1]
                }
            } else {
                const tokens = this.question.split(/\s+/);
                if (tokens.length === 0 || tokens[tokens.length - 1].length < 3) {
                    return false;
                }
                ctx2Match = tokens[tokens.length - 1]
            }

            this.results = this.items.filter(item => item.toLowerCase().startsWith(ctx2Match.toLowerCase()));
            const ok = this.results.length > 0;
            if (ok) {
                this.prevMatch = ctx2Match;
            } else {
                this.prevMatch = '';
            }
            return ok;
        },
        onChange(event) {
            
            if (this.filterResults()) {
                this.isOpen = true;
            } else {
                this.isOpen = false;
            }
            // console.log("onChange value:" + event.target.value);
            this.$emit('update:modelValue', event.target.value);
        },
        setResult(result) {
            if (!result) {
                return;
            }
            console.log("result:" + result)
            if (result.indexOf(' ') === -1) {
                const idx = this.question.lastIndexOf(' ');
                var remainder = this.question;
                if (idx === -1) {
                    this.question = result;
                    this.$emit('update:modelValue', this.question);
                } else {
                    remainder = this.question.substring(0, idx + 1);
                    this.question = remainder + result;
                    // console.log("remainder:" + remainder);
                    // console.log("autocompleted question1:" + this.question);
                    this.$emit('update:modelValue', this.question);
                }
            } else {
                const result_tokens = this.tokenize(result);
                const tokens = this.tokenize(this.question);
                const matching = this.findMatching(tokens, result_tokens);
                if (matching.length === 0) {
                    this.question = result;
                    this.$emit('update:modelValue', this.question);
                } else {
                    // console.log(matching);
                    const idx = matching[0].start;
                    this.question = this.question.substring(0, idx) + result;
                    console.log("autocompleted question2:" + this.question);
                    this.$emit('update:modelValue', this.question);
                }
            }
            this.isOpen = false;
            this.$refs.inputField.focus();
        },
        findMatching(tokens, result_tokens) {
            let i = tokens.length - 1, j = 0;
            let rt_start = result_tokens.length - 1;
            const matching = [];
            while (i >= 0) {
                let token = tokens[i].token.toLowerCase();
                for (j = rt_start; j >= 0; j--) {
                    if (result_tokens[j].token.toLowerCase().indexOf(token) !== -1) {
                        matching.push(tokens[i]);
                        rt_start = j - 1;
                        break;
                    }
                }
                i--;
            }
            return matching.reverse();
        },
        handleClickOutside(event) {
            // console.log('$el: ' + this.$el);
            if (!this.$el.contains(event.target)) {
                this.isOpen = false;
                this.results = [];
                this.arrowCounter = -1;
                // console.log('isOpen:' + this.isOpen);
            }
        },
        onArrowDown() {
            if (this.arrowCounter < this.results.length) {
                this.arrowCounter++;
            }
            console.log("onArrowDown: " + this.arrowCounter);
        },
        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter--;
            }
        },
        onEnter() {
            this.setResult(this.results[this.arrowCounter]);
            this.arrowCounter = -1;
            this.isOpen = false;
        },
        tokenize(text) {
            let i = 0, offset = 0;
            let in_tok = false;
            const tokens = [];
            for (i = 0; i < text.length; i++) {
                const ch = text.charAt(i);
                if ((ch === ' ') || (ch === '\t') || (ch === '\n')) {
                    if (in_tok) {
                        tokens.push({
                            token: text.substring(offset, i),
                            start: offset,
                            end: i
                        });
                        in_tok = false;
                    }
                } else {
                    if (!in_tok) {
                        offset = i;
                        in_tok = true;
                    }
                }
            }
            if (offset < text.length) {
                tokens.push({
                    token: text.substring(offset, text.length),
                    start: offset,
                    end: text.length
                });
                return tokens;
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    unmounted() {
        document.removeEventListener('click', this.handleClickOutside)
    }
}
</script>
<style>
.autocomplete {
    position: relative;

}

.autocomplete-results {
    background-color: white;
    position: absolute;
    padding: 0;
    margin: 0;
    border: 1px solid #d4d4d4;
    /* height: 120px; */
    /* max-width: 300px; */
    width: 100%;
    min-height: 1em;
    max-height: 6em;
    overflow: auto;
    z-index: 20000000;
    top: 40px;
    left: 0;
    right: 0;
    opacity: 100%;

}

.autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
    z-index: 2000;
    /*  border-bottom: 1px solid #d4d4d4; */
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
    background-color: #4aae9b;
    color: white;
}
</style>